import {
    encodedArrayCodec,
    withModeCodec,
    ZodCodecMapToType,
} from "@impero-com/ui/domain";

import { DeltaForString, OnlyAt } from "api/generated/model";

export type Delta<T> =
    | (Omit<Extract<DeltaForString, { type: "Unchanged" }>, "value"> & {
          value: T;
      })
    | (Omit<Extract<DeltaForString, { type: "Changed" }>, "start" | "end"> & {
          start: T;
          end: T;
      });

export interface ScaleValue {
    label: string;
    index: number;
}

export interface RiskInsightsTableRow {
    id: string;
    name: string;
    onlyAt: OnlyAt | null;
    path: string[];
    entity: string;
    inherentImpact: Delta<ScaleValue | null>;
    inherentLikelihood: Delta<ScaleValue | null>;
    residualImpact: Delta<ScaleValue | null>;
    residualLikelihood: Delta<ScaleValue | null>;
    coverage: Delta<number | null>;
}

export const MAP_INSIGHTS_COLUMN_IDS = {
    PATH: "path",
    RISK: "risk",
    ENTITY: "entity",
    IMPACT: "impact",
    LIKELIHOOD: "likelihood",
    COVERAGE: "coverage",
    // Set via heatmap
    FOCUS: "focus",
} as const;

export const mapInsightsColumnFiltersCodecMap = {
    [MAP_INSIGHTS_COLUMN_IDS.PATH]: withModeCodec(encodedArrayCodec),
    [MAP_INSIGHTS_COLUMN_IDS.RISK]: withModeCodec(encodedArrayCodec),
    [MAP_INSIGHTS_COLUMN_IDS.ENTITY]: withModeCodec(encodedArrayCodec),
    [MAP_INSIGHTS_COLUMN_IDS.IMPACT]: withModeCodec(encodedArrayCodec),
    [MAP_INSIGHTS_COLUMN_IDS.LIKELIHOOD]: withModeCodec(encodedArrayCodec),
    [MAP_INSIGHTS_COLUMN_IDS.COVERAGE]: withModeCodec(encodedArrayCodec),
    [MAP_INSIGHTS_COLUMN_IDS.FOCUS]: withModeCodec(encodedArrayCodec),
};

export type Values<T> = T[keyof T];
export type MapInsightsColumnFilters = ZodCodecMapToType<
    typeof mapInsightsColumnFiltersCodecMap
>;
